import React from 'react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import './date-picker-override.css';

const DatePicker: React.FC<ReactDatePickerProps> = ({ ...props }) => {
  return <ReactDatePicker {...props} />;
};

export default DatePicker;
